const formatAddress = (location) => {
  const { address1, address2, city, region, postalCode } = location.address;
  return [
    address1 ? `${address1}, ` : "",
    address2 ? `${address2}, ` : "",
    city ? `${city}, ` : "",
    region ? `${region}, ` : "",
    postalCode ? postalCode : ""
  ].join("");
};
const paymentGatewayTransformer = (location) => {
  const result = {
    use: location.rapidstor.paymentGateways.use,
    gatewayToUse: location.rapidstor.paymentGateways.gatewayToUse,
    bypassSitelinkProcessing: location.rapidstor.paymentGateways.bypassSitelinkProcessing,
    gateways: {}
  };
  if (location.rapidstor.paymentGateways.use) {
    switch (location.rapidstor.paymentGateways.gatewayToUse) {
      case "r6Pay":
        result.gateways = {
          r6Pay: {
            currency: location.rapidstor.paymentGateways.r6Pay.currency,
            useTestEnv: location.rapidstor.paymentGateways.r6Pay.useTestEnv,
            accessToken: location.rapidstor.paymentGateways.r6Pay.accessToken
          }
        };
        break;
    }
  }
  return result;
};
const locationTransformer = (location) => {
  const name = location.sSiteName.toLowerCase().trim().replace(/[\s_'-]+/g, "-").replace(/[^\w\s-]/g, "").replace(/^-+|-+$/g, "");
  return {
    name: location.sSiteName,
    slug: name,
    locationId: location.SiteID,
    locationCode: location.sLocationCode,
    corpCode: location.sCorpCode,
    contactName: location.sContactName,
    contactEmail: location.sEmailAddress,
    contactPhone: location.sSitePhone,
    websiteUrl: location.sWebSiteURL,
    latitude: parseFloat(location.dcLatitude),
    longitude: parseFloat(location.dcLongitude),
    timezoneOffset: location.iGMTTimeOffset,
    administrative: {
      testMode: location.administrative.testMode,
      useMtasForAuth: location.administrative.useMtasForAuth
    },
    address: {
      address1: location.sSiteAddr1,
      address2: location.sSiteAddr2,
      city: location.sSiteCity,
      region: location.sSiteRegion,
      postalCode: location.sSitePostalCode,
      country: location.sSiteCountry
    },
    rapidstor: {
      allowMoveIn: location.rapidstor.allowMoveIn,
      allowReservation: location.rapidstor.allowReservation,
      allowSaveQuote: location.rapidstor.allowSaveQuote,
      allowedCreditCardTypes: {
        visa: location.rapidstor.allowedCreditCardTypes.visa,
        mastercard: location.rapidstor.allowedCreditCardTypes.mastercard,
        amex: location.rapidstor.allowedCreditCardTypes.amex,
        discover: location.rapidstor.allowedCreditCardTypes.discover
      },
      areaSizeSymbol: location.rapidstor.areaSizeSymbol,
      completeMoveinUrl: location.rapidstor.completeMoveinURL,
      reservationNumberOfDaysInAdvanceLimit: location.rapidstor.reservationNumberOfDaysInAdvanceLimit,
      reservationNumberOfDaysInAdvanceMinimum: location.rapidstor.reservationNumberOfDaysInAdvanceMinimum,
      reservationNumberOfDaysInAdvanceChargeFee: location.rapidstor.reservationNumberOfDaysInAdvanceChargeFee,
      moveinNumberOfDaysInAdvanceLimit: location.rapidstor.moveinNumberOfDaysInAdvanceLimit,
      includeReservedUnitsInOccupied: location.rapidstor.includeReservedUnitsInOccupied,
      country: location.rapidstor.country,
      currency: location.rapidstor.currency,
      currencySymbol: location.rapidstor.currencySymbol,
      currencySymbolPositionOverride: location.rapidstor.currencySymbolPositionOverride ?? "none",
      autoESignRedirect: location.rapidstor.autoESignRedirect,
      eSignReturnUrl: location.rapidstor.eSignReturnUrl,
      jblRedirects: {
        afterMoveIn: {
          enabled: location.rapidstor.jblRedirects?.afterMoveIn?.enabled ?? false,
          url: location.rapidstor.jblRedirects?.afterMoveIn?.url ?? ""
        },
        afterUnpaidReservation: {
          enabled: location.rapidstor.jblRedirects?.afterUnpaidReservation?.enabled ?? false,
          url: location.rapidstor.jblRedirects?.afterUnpaidReservation?.url ?? ""
        },
        afterPaidReservation: {
          enabled: location.rapidstor.jblRedirects?.afterPaidReservation?.enabled ?? false,
          url: location.rapidstor.jblRedirects?.afterPaidReservation?.url ?? ""
        }
      },
      dateFormat: location.rapidstor.dateFormat,
      mediumLargeSizes: location.rapidstor.mediumLargeSize,
      smallMediumSizes: location.rapidstor.smallMediumSize,
      pushRate: location.rapidstor.pushRate,
      showWeeklyRates: location.rapidstor.showWeeklyRates,
      siteLogo: location.rapidstor.siteLogo,
      sizeSymbol: location.rapidstor.sizeSymbol,
      hideUnitsMinAvailable: location.rapidstor.hideUnitsMinAvailable,
      hideQuickSearch: location.rapidstor.hideQuickSearch,
      showVehicleQuickSearch: location.rapidstor.showVehicleQuickSearch,
      spaceCalculatorValues: location.rapidstor.spaceCalculatorValues,
      groupDescriptors: location.rapidstor.unitListing.groupDescriptors,
      useMultilevel: location.rapidstor.unitListing.useMultilevel,
      minAvailableUnits: location.rapidstor.minAvailableUnits,
      useDescriptorTitle: location.rapidstor.useDescriptorTitle,
      showPricesButtonText: location.rapidstor.showPricesButtonText,
      quickReserveButtonText: location.rapidstor.quickReserveButtonText,
      payNowButtonText: location.rapidstor.payNowButtonText,
      payLaterButtonText: location.rapidstor.payLaterButtonText,
      showPricesShowNeeded: location.rapidstor.showPricesShowNeeded,
      showPricesCreatesLead: location.rapidstor.showPricesCreatesLead,
      showPricesBehaviour: {
        createLead: location.rapidstor.showPricesBehaviour.createLead,
        sendEmail: location.rapidstor.showPricesBehaviour.sendEmail
      },
      tenantAccounts: location.rapidstor.tenantAccounts,
      hidePrices: location.rapidstor.hidePrices,
      hideStandardPrices: location.rapidstor.hideStandardPrices,
      noAvailableUnitsText: location.rapidstor.noAvailableUnitsText,
      noAvailableUnitsSecondaryText: location.rapidstor.noAvailableUnitsSecondaryText,
      noAvailableUnitsSecondaryAction: location.rapidstor.noAvailableUnitsSecondaryAction,
      callSiteCta: {
        label: location.rapidstor.callSiteCta?.label ?? "",
        type: location.rapidstor.callSiteCta?.type ?? "phone",
        value: location.rapidstor.callSiteCta?.value ?? ""
      },
      saveQuoteButtonText: location.rapidstor.saveQuoteButtonText,
      saveQuotePopupText: location.rapidstor.saveQuotePopupText,
      useDealCoupons: location.rapidstor.useDealCoupons,
      useBoxShopCoupons: location.rapidstor.useBoxShopCoupons,
      dangerousGoodsWarning: location.rapidstor.dangerousGoodsWarning,
      assistanceMoving: location.rapidstor.assistanceMoving,
      assistanceMovingEmailAddress: location.rapidstor.assistanceMovingEmailAddress,
      pickupEnabled: location.rapidstor.pickupEnabled,
      legacyPickupLocationsEnabled: location.rapidstor.legacyPickupLocationsEnabled,
      legacyPickupLocations: location.rapidstor.legacyPickupLocations,
      wizards: {
        moveinSingle: location.rapidstor.wizards.moveinSingle,
        common: {
          titles: location.rapidstor.wizards.common?.titles
        }
      },
      creditCardContent: location.rapidstor.wizards.moveinSingle?.creditCardContent,
      directDebitContent: location.rapidstor.wizards.moveinSingle?.directDebitContent,
      paymentGateways: paymentGatewayTransformer(location),
      useAutoBilling: location.rapidstor.useAutoBilling,
      autoBillCheckedByDefault: location.rapidstor.autoBillCheckedByDefault,
      requireAutobill: location.rapidstor.requireAutobill,
      creditCardForAutobill: {
        enabled: location.rapidstor.creditCardForAutobill.enabled
      },
      directDebit: {
        enabled: location.rapidstor.directDebit.enabled,
        creditAmount: location.rapidstor.directDebit.creditAmount
      },
      datesClosed: location.rapidstor.datesClosed,
      siteOpeningDate: location.rapidstor.siteOpeningDate,
      carouselListing: location.administrative.carouselListing,
      moveinRedirectUrl: location.rapidstor.moveinRedirectUrl,
      forceInitialCard: location.rapidstor.forceInitialCard,
      alwaysAllowPricingPage: location.rapidstor.alwaysAllowPricingPage,
      privacyPolicyUrl: location.rapidstor.privacyPolicyUrl ?? "",
      termsAndConditionsUrl: location.rapidstor.termsAndConditionsUrl ?? "",
      features: location.rapidstor.features
    },
    scaConfiguration: location.scaConfiguration,
    deleted: location.deleted,
    archived: location.bArchived == "true",
    rapidstorEnabled: location.rapidstorEnabled,
    token: location.token,
    createdAt: location.dCreated,
    updatedAt: location.dUpdated,
    settings: {
      logo: location.rapidstor.siteLogo,
      groundFloor: Number(location.rapidstor.groundFloor || 0),
      groupUnitsByFloor: location.rapidstor.unitListing.useMultilevel,
      billingDefault: location.rapidstor.billingDefault,
      sizeSymbol: location.rapidstor.sizeSymbol,
      areaSizeSymbol: location.rapidstor.areaSizeSymbol,
      allowMoveIn: location.rapidstor.allowMoveIn,
      unitDimensionDisplay: location.rapidstor.unitDimensionDisplay ?? "widthByLength",
      marketingSurvey: location.rapidstor.marketingSurvey,
      unitSortOrder: [
        location.rapidstor.unitListing.sortOrder.primary,
        location.rapidstor.unitListing.sortOrder.secondary,
        location.rapidstor.unitListing.sortOrder.tertiary
      ].filter((sortOrder) => sortOrder !== "none")
    },
    skin: {
      accentColours: {
        primary: location.skin.accentColours.primary
      },
      defaultUnitPicture: location.skin.defaultUnitPicture,
      mainColour: location.skin.mainColour,
      highlightColour: location.skin.highlightColour,
      themeColour: location.skin.themeColour,
      moveinTimeRemaining: location.skin.moveinTimeRemaining
    },
    hours: location.hours
  };
};
export {
  formatAddress,
  locationTransformer,
  paymentGatewayTransformer
};
//# sourceMappingURL=Location.mjs.map